import authAxios from 'src/modules/shared/axios/authAxios'

export default class HomeService {
  static async fetchVideosForCategory(categoryApiString: string) {
    return await authAxios.get(`/api/videos/${categoryApiString}`)
  }
}
